import React from 'react';
import { useState, useEffect } from 'react';
import MainHeader from '../../Components/MainHeader/MainHeader';
import { Typeahead } from 'react-bootstrap-typeahead';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import {postData} from '../../Essentials/common_fn';

import {AdminUrl,UpdateUserUrl} from '../../Essentials/variables';
import _ from 'lodash';
import './ManagementSystem.css';

// function changeAccess(empid,admin,access){
//   "userid":empid,
//   "admin": (admin===true) ?"Yes":"No",
//   "access": (access===true)? "Yes":"No"
// });
const allAccessType = ["HO","CENTRAL 1","EAST 1","NORTH 1","SOUTH 2","SOUTH EAST 1","Central","North","South East","CENTRAL 3","CENTRAL 4","NORTH 4","East","West","EAST 2","NORTH 3","SOUTH EAST 2","WEST 2","WEST 3","South","CENTRAL 2","EAST 3","NORTH 2","SOUTH 1","SOUTH 3","WEST 1"];
export default function ManagementSystem(props) {
  const [tableData, setTableData] = useState();
  const [params,setParams] = useState({});
  const [updateUser,setUpdateUser] = useState({});
  const [searchEmpID,setSearchEmpID] = useState();
  const [currentPage,setCurrentPage] = useState(1);
  const [key, setKey] = useState('home');
//   {
//     "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoyOTQ4MDIsImlhdCI6MTY3MzAxMTM3NSwiZXhwIjoxNjczMDE0Mzc1fQ.htL3PkwOcTRYlmX9ZdnTS5AWupBjw2nBIcno9CKh3h0",
//     "page":1,
//     "limit":10,
//     "filter":{
//           "id":"1234",
//           "region_code" : ["SOUTH 1","SOUTH 2"],
//             "action" : "accepted",
//           "admin_access" : "rejected"
//     }
// }
function updateTableData(parameters){
  postData(AdminUrl,parameters).then((data)=>{
//     accessname
// accesstype

    console.log(data);
    setTableData(data.map((item) => {
      let blk = <tr key={item.user_id}>
        <td>{item?.user_id}</td>
        <td>{item?.name}</td>
        <td>{item?.accesstype}</td>
        <td>{item?.accessname}</td>
        {/* <td>{item.ofc_code.map((code) => (<Button variant="secondary" style={{ 'width': 'auto' }} disabled>{code}</Button>))}</td> */}
        <td style={{width:'90px'}}>
          <label className="switch">
          <input type="checkbox" defaultChecked={item?.access === "Yes" ? true : false} onClick={(e)=>(setUpdateUser({"userid":item.user_id,"access": (e.target.checked) ?"Yes":"No"}))}/>
          <span className="slider round"></span>
        </label>
        </td>
        <td style={{ width:'90px'}}>
          <label className="switch">
          <input type="checkbox" defaultChecked={item?.admin === "Yes" ? true : false}  onClick={(e)=>(setUpdateUser({"userid":item.user_id,"admin": (e.target.checked) ?"Yes":"No"}))}/>
          <span className="slider round"></span>
        </label></td>
      </tr>
      return blk;
    }
    ));
  });
}
useEffect(()=>{
      postData(UpdateUserUrl,updateUser).then((data)=>{
        // console.log("table update executed");
      });
},[updateUser]);

  useEffect(()=>{
updateTableData(params);
let p ={"page":currentPage,
"limit":5,
"filter":params}
updateTableData(p);
  },[params,currentPage]);



  return (
    <>
      <MainHeader nav={props.nav}/>
      <h4 style={{
          color: '#171b8f',
          'font-family': 'poppins',
          textAlign: 'Center',
          padding: '10px'
        }}>ADMIN CONTROL</h4>



      <div style={{ 'borderRadius': '5px 5px  5px  5px', 'border': '3px solid  #171b8f', 'margin': '30px', 'padding': '15px'}}>
      <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={(k) => setKey(k)}
      className="mb-3"
    >
      <Tab eventKey="home"  title="Employee ID/Dealer Email Filter">
      <div style={{ 'width': '900px' }} >
          <InputGroup>
            <Form.Control id="empidfilter" placeholder="Employee ID / Dealer Email ID" onChange={(e)=>{setSearchEmpID(e.target.value)}}/>
            <button id="empidSubmitBtn" onClick={()=>{setParams({"id":searchEmpID})}}>Submit</button>
          </InputGroup> 
        </div>
      </Tab>

      <Tab eventKey="profile" title="Access Filter">
        <div style={{ 'display': 'flex', 'justifyContent': 'space-around' }}>
      <Typeahead placeholder='Enter Access Name' options={allAccessType} onChange={(o) => {setParams({...params,"access_name":o[0]})}} />
        <Form.Select style={{ 'width': '180px' }} onChange={(v) => { setParams({...params,"action":v.target.value}) }} aria-label="Action">
          <option value="">Select Action</option>
          <option value="Yes">Accept</option>
          <option value="No">Pending</option>
        </Form.Select>
        <Form.Select style={{ 'width': '200px' }} onChange={(v) => { setParams({...params,"admin_access":v.target.value})}} aria-label="Action">
          <option value="">Select Admin Access</option>
          <option value="Yes" disabled={params?.action === "No"?true:false}>Accept</option>
          <option value="No">Pending</option>
        </Form.Select>
        </div>
      </Tab>
    </Tabs>
        
        
        
      </div>

      


        <div style={{"margin":"30px"}}>
      <Table bordered hover responsive>
        <thead>
          <tr>
            <th>Employee ID/ Dealer Email ID</th>
            <th>Name</th>
            <th>Access Type</th>
            <th>Access Name</th>
            <th>Action</th>
            <th>Admin access</th>
          </tr>
        </thead>
        <tbody>
          {tableData}
        </tbody>
      </Table>
      </div>
      <Pagination style={{ 'display': 'flex', 'justifyContent': 'center' }}>
        <Pagination.Prev onClick={()=>{setCurrentPage(currentPage - 1)}} disabled = {currentPage === 1}/>
        <Pagination.Item active={true} onClick={() => { }}>{currentPage}</Pagination.Item>
        <Pagination.Item onClick={() => { setCurrentPage(currentPage + 1)}}>{currentPage + 1}</Pagination.Item>
        <Pagination.Item onClick={() => { setCurrentPage(currentPage + 2)}}>{currentPage + 2}</Pagination.Item>
        <Pagination.Item onClick={() => { setCurrentPage(currentPage + 3)}}>{currentPage + 3}</Pagination.Item>
        <Pagination.Ellipsis onClick={() => { setCurrentPage(currentPage + 4)}} />
      </Pagination>
    </>
  );

}